import { DefaultTemplate } from "components/modal/templates";
import { paths } from "helpers/paths";
import React from "react";

export default class ParallelBidChangeModal extends DefaultTemplate {
    close = () => {
        const { actions, close } = this.props;
        actions.cancel?.();
        this.setState({ isLoading: false });
        return close();
    };

    renderHeader = () => {
        const { title } = this.props;
        return (
            <div className="modal-window__header">
                <div className="modal-window__header-title">{title}</div>
                <div className="close close--sm" onClick={this.close} />
            </div>
        );
    };

    renderBody = () => {
        const withCloseAction = (action) => {
            action();
            this.props.close();
        };
        const { parallelBidId } = this.props;
        return (
            <>
                <p>
                    На составляющую заявки, которую вы пытаетесь изменить, уже назначена параллельная перецепка в заявке
                    <a
                        className="ml-1"
                        href={paths.bidShow("bid", parallelBidId)}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {parallelBidId}.
                    </a>
                    <br />
                    Выберите действие c параллельной перецепкой:
                </p>
                <div className="d-flex mb-3">
                    <div
                        className="btn btn-sm btn-brand mr-2"
                        onClick={() => withCloseAction(this.props.actions.update)}
                    >
                        Обновить точку перецепки в заявке {parallelBidId}
                    </div>
                    <div
                        className="btn btn-sm btn-danger mr-2"
                        onClick={() => withCloseAction(this.props.actions.delete)}
                    >
                        Удалить точки перецепки в двух заявках
                    </div>
                </div>
            </>
        );
    };
}
